import { SingleShiftDetails } from '../../../../../ui/features/shift-details/components/participant-details-tables/SingleShiftDetails';
import { TableLoadingBar, TableStatesContent } from '@juvare/common-data-table-ui/DataTable';
import { Box } from '@mui/material';
import React from 'react';
export const ShiftsDetailsTable = ({ columns, defaultRowsPerPage, rows, onSendMessageToVolunteers, loading, error, isVolunteerView, }) => {
    return (React.createElement(React.Fragment, null,
        loading && rows.length > 0 && React.createElement(TableLoadingBar, null),
        React.createElement(Box, null, rows.map((row) => (React.createElement(SingleShiftDetails, { columns: columns, key: row.id, row: row, defaultRowsPerPage: defaultRowsPerPage, onSendMessageToVolunteers: onSendMessageToVolunteers, isVolunteerView: isVolunteerView })))),
        React.createElement(TableStatesContent, { rows: rows, loading: loading, error: error })));
};
